import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { API_BASE_URL } from 'src/environments/environment.prod';
import { Filter, FilterPayload, FilterWithout } from '../../domain/interfaces/Filter.interface';
import { getFilterPayload } from '../../utils/filter/filter-format';

@Injectable({
  providedIn: 'root'
})
export class FilterApiService {

  private readonly http = inject(HttpClient);
  // private readonly PATH = ' ';
  private readonly PATH = 'filter';
  private readonly PATH_V2 = 'communities-filter';

  async getStateOptions(params?: FilterWithout<'states'>): Promise<any[]> {
    const filterPayload = getFilterPayload(params);
    delete filterPayload.states;
    return firstValueFrom(
      this.http.post<any>(`${API_BASE_URL}/${this.PATH_V2}/states`, filterPayload)
    );
  }

  async getMunicipalitiesOptionsV2(params?: FilterWithout<'municipalities'>): Promise<any[]> {
    const filterPayload = getFilterPayload(params);
    return firstValueFrom(
      this.http.post<any>(`${API_BASE_URL}/${this.PATH_V2}/municipalities`, filterPayload)
    );
  }

  async getIndigenousLandsOptionsV2(params?: FilterWithout<'indigenousLands'>): Promise<any[]> {
    const filterPayload = getFilterPayload(params);
    return firstValueFrom(
      this.http.post<any>(`${API_BASE_URL}/${this.PATH_V2}/indigenous-lands`, filterPayload)
    );
  }

  async getConservationUnitsOptionsV2(params?: FilterWithout<'conservationUnits'>): Promise<any[]> {
    const filterPayload = getFilterPayload(params);
    return firstValueFrom(
      this.http.post<any>(`${API_BASE_URL}/${this.PATH_V2}/conservation-units`, filterPayload)
    );
  }

  async getSpecialTerritoriesOptionsV2(params?: FilterWithout<'specialTerritories'>): Promise<any[]> {
    const filterPayload = getFilterPayload(params);
    return firstValueFrom(
      this.http.post<any>(`${API_BASE_URL}/${this.PATH_V2}/special-territories`, filterPayload)
    );
  }

  async getStatusOptions(params?: FilterWithout<'status'>): Promise<any[]> {
    const filterPayload = getFilterPayload(params);
    return firstValueFrom(
      this.http.post<any>(`${API_BASE_URL}/${this.PATH_V2}/status`, filterPayload)
    );
  }

  async getMaintenanceStatusOptions(params?: FilterWithout<'awaitingMaintenanceStatus'>): Promise<any[]> {
    const filterPayload = getFilterPayload(params);
    return firstValueFrom(
      this.http.post<any>(`${API_BASE_URL}/${this.PATH_V2}/awaiting-maintenance-status`, filterPayload)
    );
  }

  async getContractTypeOptions(params?: FilterWithout<'contractType'>): Promise<any[]> {
    const filterPayload = getFilterPayload(params);
    return firstValueFrom(
      this.http.post<any>(`${API_BASE_URL}/${this.PATH_V2}/contract-types`, filterPayload)
    );
  }

  async getConnectionTypeOptions(params?: FilterWithout<'connectionTypes'>): Promise<any[]> {
    const filterPayload = getFilterPayload(params);
    return firstValueFrom(
      this.http.post<any>(`${API_BASE_URL}/${this.PATH_V2}/connection-types`, filterPayload)
    );
  }

  async getPartnerOptions(params?: FilterWithout<'partners'>): Promise<any[]> {
    const filterPayload = getFilterPayload(params);
    return firstValueFrom(
      this.http.post<any>(`${API_BASE_URL}/${this.PATH_V2}/partners`, filterPayload)
    );
  }

  async getEnergyKitModelOptions(params?: FilterWithout<'energyKitModel'>): Promise<any[]> {
    const filterPayload = getFilterPayload(params);
    return firstValueFrom(
      this.http.post<any>(`${API_BASE_URL}/${this.PATH_V2}/energy-kit-model`, filterPayload)
    );
  }

  async getDeclaredTerritoryOptions(params?: FilterWithout<'declaredTerritory'>): Promise<any[]> {
    const filterPayload = getFilterPayload(params);
    return firstValueFrom(
      this.http.post<any>(`${API_BASE_URL}/${this.PATH_V2}/declared-territory`, filterPayload)
    );
  }

  async getWorkGroupsOptions(params?: FilterWithout<'workGroups'>): Promise<any[]> {
    const filterPayload = getFilterPayload(params);
    return firstValueFrom(
      this.http.post<any>(`${API_BASE_URL}/${this.PATH_V2}/work-groups`, filterPayload)
    );
  }

  async getAssociationOptions(params?: FilterWithout<'association'>): Promise<any[]> {
    const filterPayload = getFilterPayload(params);
    return firstValueFrom(
      this.http.post<any>(`${API_BASE_URL}/${this.PATH_V2}/association`, filterPayload)
    );
  }

  async getRouterModelOptions(params?: FilterWithout<'routerModel'>): Promise<any[]> {
    const filterPayload = getFilterPayload(params);
    return firstValueFrom(
      this.http.post<any>(`${API_BASE_URL}/${this.PATH_V2}/router-model`, filterPayload)
    );
  }
}
